import { LinearProgress } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { P2GGrid, P2GText } from '@parcel2go/core-ui';
import useProgress from '~/hooks/use-progress';
import { ProgressBarProps } from './progress-bar';

const useStyles = makeStyles()((theme) => ({
  progressBar: {
    height: theme.spacing(2),
    borderRadius: '20px'
  },
  progressBarLabel: {
    paddingBottom: 3,
    [theme.breakpoints.only('xs')]: {
      display: 'none'
    }
  },
  clickable: {
    ':hover': {
      cursor: 'pointer'
    }
  }
}));

const GetProgressBarValue = (index: number, currentIndex: number, scrollPosition: number): number => {
  const lowerIndex = index < currentIndex;
  const higherIndex = index > currentIndex;
  if (lowerIndex) {
    return 100;
  } else if (higherIndex) {
    return 0;
  } else {
    return scrollPosition;
  }
};

export const ProgressBars = ({ progressBars, currentIndex, onStepClick, formId }: ProgressBarProps) => {
  const { classes } = useStyles();
  const scrollPosition = useProgress(formId);
  return (
    <>
      {progressBars.map((val, index) => (
        <P2GGrid
          key={val.text}
          item
          flexGrow={1}
          flexShrink={1}
          flexBasis={0}
          onClick={() => onStepClick && onStepClick(index)}
        >
          <P2GText
            variant="body1"
            classNames={[classes.progressBarLabel, onStepClick && index < currentIndex ? classes.clickable : '']}
            component="p"
            colour="textSecondary"
            mb={1}
          >
            {index == currentIndex ? <strong>{val.text}</strong> : val.text}
          </P2GText>
          <LinearProgress
            className={classes.progressBar}
            data-testid={'progress-' + index}
            variant="determinate"
            value={GetProgressBarValue(index, currentIndex, scrollPosition)}
          />
        </P2GGrid>
      ))}
    </>
  );
};
